(function () {
  function init(root){
    if(!root || root.dataset.faqInit === "1") return;
    root.dataset.faqInit = "1";

    const form = root.querySelector('.mnl-faq__searchForm');
    const input = form && form.querySelector('input[name="q"]');

    const featured = root.querySelector('[data-faq-featured]');
    const resultsWrap = root.querySelector('[data-faq-results]');
    const resultsTitle = root.querySelector('[data-faq-results-title]');
    const resultRows = Array.from(root.querySelectorAll('[data-faq-result]'));
    const noResults = root.querySelector('[data-faq-no-results]');

    // Accordion (works for both featured & results)
    root.addEventListener('click', (e) => {
      const btn = e.target.closest('.mnl-faq__rowBtn');
      if(!btn) return;
      const row = btn.closest('.mnl-faq__row');
      const ans = row && row.querySelector('.mnl-faq__answer');
      if(!ans) return;

      const open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      ans.hidden = open;
    });

    // Read query param
    const params = new URLSearchParams(window.location.search);
    const q = (params.get('q') || '').trim().toLowerCase();

    // Keep input filled
    if(input) input.value = params.get('q') || '';

    if(q){
      // show results, hide featured
      if(featured) featured.hidden = true;
      if(resultsWrap) resultsWrap.hidden = false;
      if(resultsTitle) resultsTitle.innerHTML = `Résultats pour “<strong>${escapeHtml(params.get('q'))}</strong>”`;

      let shown = 0;
      resultRows.forEach(r => {
        const hay = (r.getAttribute('data-text') || '');
        const ok = hay.includes(q);
        r.hidden = !ok;
        if(ok) shown++;
      });
      if(noResults) noResults.hidden = shown !== 0;
    } else {
      // default view
      if(featured) featured.hidden = false;
      if(resultsWrap) resultsWrap.hidden = true;
    }
  }

  function escapeHtml(str){
    return (str || '').replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
  }

  function boot(){
    document.querySelectorAll('[data-faq-root]').forEach(init);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();